import { jsPDF } from "jspdf";
import { parseAssistant } from "./api";

const clean = (s) => s.replace(/\*\*(.+?)\*\*/g, "$1").replace(/[*_`#]/g, "").replace(/[^\x00-\xFF\u2013\u2014\u2018\u2019\u201C\u201D\u2022\u20AC]/g, "");

export function downloadEvaluationPdf({ t, consult, messages, diagnosis }) {
  const doc = new jsPDF({ unit: "mm", format: "a4" });
  const W = 210, M = 18, maxW = W - 2 * M;
  let y = 20;
  const ensure = (h) => { if (y + h > 280) { doc.addPage(); y = 20; } };
  const write = (text, { size = 10, bold = false, color = [40, 48, 60], gap = 1.5 } = {}) => {
    doc.setFont("helvetica", bold ? "bold" : "normal");
    doc.setFontSize(size);
    doc.setTextColor(...color);
    doc.splitTextToSize(clean(text), maxW).forEach((line) => { ensure(size * 0.45); doc.text(line, M, y); y += size * 0.42 + gap; });
  };

  doc.setFillColor(79, 138, 120);
  doc.rect(0, 0, W, 12, "F");
  write("Dr. Nova", { size: 20, bold: true, color: [30, 70, 60] });
  write(t("diagnosisTitle"), { size: 12, color: [90, 100, 110] });
  y += 2;
  write(`${t("pdfPatient")}: ${t(consult.sex)}, ${consult.age} ${t("years")}`, { bold: true });
  write(`${t("selected")}: ${consult.zone === "general" ? consult.zone_label : `${consult.zone_label} – ${consult.subzone_label}`}`);
  write(`${t("pdfDate")}: ${new Date(consult.created_at).toLocaleString()}`);
  y += 4;

  write(t("pdfInterview"), { size: 13, bold: true, color: [30, 70, 60] });
  messages.filter((m) => !m.hidden).forEach((m) => {
    const text = m.role === "user" ? m.content : parseAssistant(m.content).clean;
    if (text) write(`${m.role === "user" ? t("pdfPatient") : "Dr. Nova"}: ${text}`, { color: m.role === "user" ? [40, 48, 60] : [60, 90, 85] });
  });
  y += 4;

  write(t("diagnosisTitle"), { size: 13, bold: true, color: [30, 70, 60] });
  diagnosis.split("\n").forEach((line) => {
    const l = line.trim();
    if (!l) { y += 1.5; return; }
    if (l.startsWith("#")) { y += 2; write(l.replace(/^#+\s*/, ""), { size: 12, bold: true }); }
    else if (/^[-*]\s/.test(l)) write(`•  ${l.slice(2)}`);
    else write(l);
  });
  y += 6;
  write(t("disclaimer"), { size: 8, color: [130, 130, 130] });
  doc.save(`dr-nova-${consult.id.slice(0, 8)}.pdf`);
}
